const IS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches
const ELEMENTS = 'cursor-hover'

const DEFAULT_CLASS = 'is-cursor-default'
const MORE_CLASS = 'is-cursor-more'

class Cursor {
  constructor() {
    if (window.matchMedia('(pointer: coarse)').matches) return

    if(IS_REDUCED_MOTION) {
      document.body.classList.add('reduced-motion')
      return false
    }

    this.cursor = document.querySelector('#cursor')

    document.addEventListener('mousemove', (e) => {
      this.cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`
    });

    document.addEventListener('mousedown', () => {
      this.cursor.classList.add('click');
    });

    document.addEventListener('mouseup', () => {
      this.cursor.classList.remove('click')
    });

    window.onmousemove = (e) => {
      this.setClass(e)
    }
  }

  setClass = (e) => {
    const cursor_class = e.target.getAttribute('data-cursor')

    if(e.target.classList.contains(ELEMENTS)){
      document.body.classList.remove(DEFAULT_CLASS)
      document.body.classList.add(cursor_class)
    } else {
      document.body.classList.remove(MORE_CLASS)
      document.body.classList.add(DEFAULT_CLASS)
    }
  }
}

new Cursor();
